<template>
  <form class="banner-form" @submit.prevent="submitHandler">
    <div class="banner-form__content">
      <FormElement
        v-model:value.trim="fields.title"
        placeholder="Введите наименование"
        title="Наименование"
        isRequired
        titleClass="black-18"
        :errorText="errorFields?.title"
      />
      <h5 class="banner-form__title">
        Выберите категорию <span class="red">*</span>
      </h5>
      <div class="banner-form__toggle">
        <span :class="{ greyed: categoryToSelect !== 'products' }">Товары</span>
        <ToggleElement
          fieldKey=""
          :disabled="!isServicesAvailable || !isProductsAvailable"
          :value="categoryToSelect === 'products' ? 'services' : 'products'"
          :checked="categoryToSelect === 'services'"
          @update:value="onCategoryToSelectUpdate"
        />
        <span :class="{ greyed: categoryToSelect !== 'services' }">Услуги</span>
      </div>
      <SelectElement
        v-show="categoryToSelect === 'products'"
        :value="selectedProductCategory"
        :options="productCategories ?? []"
        objectKey="categoryId"
        label="name"
        trackBy="id"
        placeholder="Выберите категорию товара"
        title="Товары"
        searchable
        :internalSearch="false"
        :errorText="errorFields?.categoryId"
        :isLoading="isProductCategoriesLoading"
        @dataChanged="onUpdateValue"
        @search-change="productCategoriesSearchChange"
      />
      <SelectElement
        v-show="categoryToSelect === 'services'"
        :value="selectedServiceCategory"
        :options="servicesCategories ?? []"
        objectKey="serviceCategoryId"
        label="name"
        trackBy="id"
        placeholder="Выберите категорию услуг"
        title="Услуги"
        searchable
        :internalSearch="false"
        :errorText="errorFields?.serviceCategoryId"
        :isLoading="isServicesCategoriesLoading"
        @dataChanged="onUpdateValue"
        @search-change="serviceCategoriesSearchChange"
      />
      <AddImage
        :images="fields.image.preview ? [fields.image] : []"
        :height="134"
        dropzoneTitle="Добавьте фото из папки или перенесите его вручную в область загрузки"
        acceptTypes=".jpg, .png, .jpeg"
        title="Фото"
        isRequired
        @deleteImage="onRemoveImage"
        @addImage="onFileUpload"
      />
      <NotifyComponent v-if="photoErrors?.length" :text="photoErrors.join(', ')" />
      <CheckboxRadioElement
        :value="!fields.isActive"
        :checked="fields.isActive"
        label="Активен"
        fieldKey="isActive"
        @update:value="onUpdateValue"
      />
      <NotifyComponent v-if="error" :text="error" />
    </div>
    <FormActionBtns
      reversed
      class="banner-form__btns"
      :isLoading="isReqLoading"
      :disabled="isSubmitBtnDisabled"
      @cancel="$emit('close')"
    >
      {{ banner ? 'Сохранить  изменения' : 'Создать баннер' }}
    </FormActionBtns>
  </form>
</template>

<script lang="ts" src="./HomeBannerForm.ts">
</script>

<style scoped lang="scss" src="./HomeBannerForm.scss"></style>
